module.exports = __webpack_public_path__ + "static/img/logo.0cec2bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-symbol/logo.png
// module id = 0AQa
// module chunks = 89